module.exports = __webpack_public_path__ + "img/withdraw-home.c83f0f7f.jpg";